import { useEffect, useRef } from "react";

const useWebGpuDebug = () => {
  const webGpuDebugInitRef = useRef(false);

  useEffect(() => {
    if (webGpuDebugInitRef.current) return;
    webGpuDebugInitRef.current = true;

    const debugOn = new URLSearchParams(window.location.search).has("wgpuDebug");
    if (!debugOn) return;

    const onRejection = (event) => {
      console.error("[WebGPU] Unhandled rejection:", event?.reason || event);
    };

    window.addEventListener("unhandledrejection", onRejection);

    (async () => {
      try {
        if (!("gpu" in navigator)) return;
        const adapter = await navigator.gpu.requestAdapter();
        if (!adapter) return;

        const device = await adapter.requestDevice();
        window.__wgpuDebugDevice = device;

        device.lost.then((info) => {
          console.error("[WebGPU] Device lost:", info?.message || "(no message)");
        });

        console.log("[WebGPU] Adapter:", adapter?.name || "(unknown)");
        console.log("[WebGPU] Limits:", device.limits);
      } catch (error) {
        console.warn("[WebGPU] Debug hook failed:", error);
      }
    })();

    return () => {
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);
};

export default useWebGpuDebug;
